import React, { useState } from 'react';
import {
  resolveCityOptions,
  resolveCountryOptions,
  resolveDefaultCountry,
  resolveCityPlaceholder,
} from '../utils/locationData';

/**
 * Pays + Ville (ville always full-width). Use renderCountry/renderCity to split layout.
 * Pass activeCountry + onActiveCountryChange + cityResetKey when country and city are in separate rows.
 */
const CountryCityFields = ({
  contactForm = {},
  countryName = 'country',
  cityName = 'city',
  countryId = 'country',
  cityId = 'city',
  countryRequired = false,
  cityRequired = false,
  countryLabel = 'Pays',
  cityLabel = 'Ville',
  countryValue,
  cityValue,
  onCountryChange,
  onCityChange,
  defaultCountry: defaultCountryProp,
  renderCountry = true,
  renderCity = true,
  activeCountry: activeCountryProp,
  onActiveCountryChange,
  cityResetKey: cityResetKeyProp,
}) => {
  const defaultCountry = defaultCountryProp || resolveDefaultCountry(contactForm.defaultCountry);
  const [internalCountry, setInternalCountry] = useState(defaultCountry);
  const [internalCityKey, setInternalCityKey] = useState(0);

  const isControlled = countryValue !== undefined;
  const activeCountry = activeCountryProp ?? (isControlled ? countryValue : internalCountry);
  const cityKey = cityResetKeyProp ?? internalCityKey;

  const countryOptions = resolveCountryOptions(contactForm.countries);
  const cityOptions = resolveCityOptions(activeCountry, contactForm.cities);
  const cityPlaceholder = resolveCityPlaceholder(activeCountry);

  const handleCountryChange = (e) => {
    const value = e.target.value;
    if (onActiveCountryChange) {
      onActiveCountryChange(value);
    } else if (!isControlled) {
      setInternalCountry(value);
      setInternalCityKey((k) => k + 1);
    }
    onCountryChange?.(value);
  };

  const handleCityChange = (e) => {
    onCityChange?.(e.target.value);
  };

  return (
    <>
      {renderCountry && (
        <div className="form-group">
          <label htmlFor={countryId}>
            <i className="fas fa-globe-africa" aria-hidden="true" /> {countryLabel}
            {countryRequired ? ' *' : ''}
          </label>
          <select
            id={countryId}
            name={countryName}
            required={countryRequired}
            value={isControlled ? countryValue : activeCountry}
            onChange={handleCountryChange}
          >
            {countryOptions.map((country) => (
              <option key={country} value={country}>{country}</option>
            ))}
          </select>
        </div>
      )}

      {renderCity && (
        <div className="form-group form-group-full">
          <label htmlFor={cityId}>
            <i className="fas fa-map-marker-alt" aria-hidden="true" /> {cityLabel}
            {cityRequired ? ' *' : ''}
          </label>
          <select
            id={cityId}
            name={cityName}
            key={`${activeCountry}-${cityKey}`}
            required={cityRequired}
            value={cityValue}
            defaultValue={cityValue !== undefined ? undefined : ''}
            onChange={handleCityChange}
          >
            <option value="">{cityPlaceholder}</option>
            {cityOptions.map((city) => (
              <option key={city} value={city}>{city}</option>
            ))}
          </select>
        </div>
      )}
    </>
  );
};

export default CountryCityFields;
